import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summaryDuration',
  standalone: false,
})
export class SummaryDurationPipe implements PipeTransform {
  transform(duration: string): string {
    let formattedDuration = '';
    if (!duration || /^\s*$/.test(duration)) {
      return formattedDuration;
    }
    let split = duration.split(':');
    if (split === undefined || split.length !== 3) {
      return duration;
    }
    if (split[0] !== undefined && split[0] !== '00') {
      formattedDuration += split[0] + 'h';
    }
    if (split[1] !== undefined && split[1] !== '00') {
      formattedDuration += split[1] + 'm';
    }
    if (split[2] !== undefined && split[2] !== '00') {
      formattedDuration += split[2] + 's';
    }
    return formattedDuration;
  }
}
